import { createSlice } from "@reduxjs/toolkit";

const settingsSlice = createSlice({
  name: "settingData",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    getSettingsRequest: (state) => {
      state.loading = true;
    },
    getSettingsSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    getSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveSettingsRequest: (state) => {
      state.loading = true;
    },
    saveSettingsSuccess: (state) => {
      state.loading = false;
    },
    saveSettingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveBirthdayGiftRequest: (state) => {
      state.loading = true;
    },
    saveBirthdayGiftSuccess: (state) => {
      state.loading = false;
    },
    saveBirthdayGiftFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveRegistrationGiftRequest: (state) => {
      state.loading = true;
    },
    saveRegistrationGiftSuccess: (state) => {
      state.loading = false;
    },
    saveRegistrationGiftFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    bulkGiftRequest: (state) => {
      state.loading = true;
    },
    bulkGiftSuccess: (state) => {
      state.loading = false;
    },
    bulkGiftFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addMinQtyRequest: (state) => {
      state.loading = true;
    },
    addMinQtySuccess: (state) => {
      state.loading = false;
    },
    addMinQtyFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addHsnCodeRequest: (state) => {
      state.loading = true;
    },
    addHsnCodeSuccess: (state) => {
      state.loading = false;
    },
    addHsnCodeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    metalRateStatesRequest: (state) => {
      state.loading = true;
    },
    metalRateStatesSuccess: (state) => {
      state.loading = false;
    },
    metalRateStatesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveOfferRequest: (state) => {
      state.loading = true;
    },
    saveOfferSuccess: (state) => {
      state.loading = false;
    },
    saveOfferFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    expireOfferRequest: (state) => {
      state.loading = true;
    },
    expireOfferSuccess: (state) => {
      state.loading = false;
    },
    expireOfferFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    createOrUpdateOfferRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    createOrUpdateOfferSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    createOrUpdateOfferFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateBenefitStatusRequest: (state) => {
      state.loading = true;
    },
    updateBenefitStatusSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    updateBenefitStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getUiArrangementRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getUiArrangementSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    getUiArrangementFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveUiArrangementRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    saveUiArrangementSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    saveUiArrangementFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    savePaymentGatewayCountriesRequest: (state) => {
      state.loading = true;
    },
    savePaymentGatewayCountriesSuccess: (state) => {
      state.loading = false;
    },
    savePaymentGatewayCountriesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getSettingsRequest,
  getSettingsSuccess,
  getSettingsFailure,
  saveSettingsRequest,
  saveSettingsSuccess,
  saveSettingsFailure,
  saveBirthdayGiftRequest,
  saveBirthdayGiftSuccess,
  saveBirthdayGiftFailure,
  saveRegistrationGiftRequest,
  saveRegistrationGiftSuccess,
  saveRegistrationGiftFailure,
  bulkGiftRequest,
  bulkGiftSuccess,
  bulkGiftFailure,
  addMinQtyRequest,
  addMinQtySuccess,
  addMinQtyFailure,
  addHsnCodeRequest,
  addHsnCodeSuccess,
  addHsnCodeFailure,
  metalRateStatesRequest,
  metalRateStatesSuccess,
  metalRateStatesFailure,
  saveOfferRequest,
  saveOfferSuccess,
  saveOfferFailure,
  expireOfferRequest,
  expireOfferSuccess,
  expireOfferFailure,
  createOrUpdateOfferRequest,
  createOrUpdateOfferSuccess,
  createOrUpdateOfferFailure,
  updateBenefitStatusRequest,
  updateBenefitStatusSuccess,
  updateBenefitStatusFailure,
  getUiArrangementRequest,
  getUiArrangementSuccess,
  getUiArrangementFailure,
  saveUiArrangementRequest,
  saveUiArrangementSuccess,
  saveUiArrangementFailure,
  savePaymentGatewayCountriesRequest,
  savePaymentGatewayCountriesSuccess,
  savePaymentGatewayCountriesFailure,
} = settingsSlice.actions;

export default settingsSlice.reducer;
